export const SET_DARKMODE = 'SET_DARKMODE';
export const SELECT_DARKMODE = 'SELECT_DARKMODE';